import {PageKeys} from ".";

export const PAGES_EXCLUDED_FROM_NON_BLOCKING_ACTIONS = ["login", "logout"];

export const URLS: Record<PageKeys, string> = {
	calculator: "/"
};
